import React from "react"

function Logo(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1702.3 516.1"
      width="125px"
      height="38px"
      {...props}
    >
      <style>{".prefix__st0{fill:#999}.prefix__st1{fill:#2b69b3}"}</style>
      <g id="prefix__Layer_1">
        <path
          transform="rotate(-29.495 64.97 100.046)"
          className="prefix__st0"
          d="M50.1 88.8h29.7v22.4H50.1z"
        />
        <path
          transform="rotate(-29.495 116.625 70.835)"
          className="prefix__st0"
          d="M101.8 59.6h29.7V82h-29.7z"
        />
        <path
          transform="rotate(-29.495 168.281 41.624)"
          className="prefix__st0"
          d="M153.5 30.4h29.7v22.4h-29.7z"
        />
        <path
          className="prefix__st0"
          d="M5.7 120.7c-3.5 2-5.7 5.7-5.7 9.8v17.3h22.4l9.3-16-11-19.5-15 8.4zM0 305.3h22.4v31.5H0zm0-63h22.4v31.5H0zm0-63h22.4v31.5H0zm0 189.1v17.3c0 4 2.2 7.8 5.7 9.8l15 8.5 11-19.5-9.3-16H0z"
        />
        <path
          transform="rotate(-60.508 64.978 416.065)"
          className="prefix__st0"
          d="M53.8 401.2h22.4v29.7H53.8z"
        />
        <path
          transform="rotate(-60.508 116.637 445.282)"
          className="prefix__st0"
          d="M105.4 430.4h22.4v29.7h-22.4z"
        />
        <path
          transform="rotate(-60.508 168.295 474.499)"
          className="prefix__st0"
          d="M157.1 459.6h22.4v29.7h-22.4z"
        />
        <path
          transform="rotate(-29.565 275.71 474.48)"
          className="prefix__st0"
          d="M260.9 463.3h29.6v22.4h-29.6z"
        />
        <path
          transform="rotate(-29.565 327.198 445.275)"
          className="prefix__st0"
          d="M312.4 434.1H342v22.4h-29.6z"
        />
        <path
          transform="rotate(-29.565 378.684 416.07)"
          className="prefix__st0"
          d="M363.9 404.9h29.6v22.4h-29.6z"
        />
        <path
          className="prefix__st0"
          d="M421.1 305.3h22.4v31.5h-22.4zm0-126h22.4v31.5h-22.4zm0 63h22.4v31.5h-22.4zm16.7-121.6l-15-8.5-11.1 19.5 9.3 16h22.4v-17.3c.1-4-2.1-7.7-5.6-9.7z"
        />
        <path
          transform="rotate(-60.436 378.68 100.036)"
          className="prefix__st0"
          d="M367.5 85.2h22.4v29.6h-22.4z"
        />
        <path
          transform="rotate(-60.436 327.193 70.83)"
          className="prefix__st0"
          d="M316 56h22.4v29.6H316z"
        />
        <path
          transform="rotate(-60.436 275.706 41.626)"
          className="prefix__st0"
          d="M264.5 26.8h22.4v29.6h-22.4z"
        />
        <path
          transform="rotate(-29.506 64.96 355.189)"
          className="prefix__st0"
          d="M50.1 344h29.7v22.4H50.1z"
        />
        <path
          transform="rotate(-60.423 378.687 355.194)"
          className="prefix__st0"
          d="M367.5 340.4h22.4V370h-22.4z"
        />
        <path className="prefix__st0" d="M210.9 60h22.4v31.5h-22.4z" />
        <path
          className="prefix__st1"
          d="M101.7 192.1V324c0 4 2.2 7.8 5.7 9.7l108.7 61.6a10.838 10.838 0 0011 0l109-61.6c3.5-2 5.7-5.7 5.7-9.8V192.1c0-4-2.2-7.8-5.7-9.8l-109-61.6c-3.4-1.9-7.6-1.9-11 0l-108.7 61.6c-3.5 2-5.7 5.8-5.7 9.8zm22.4 19.2l86.3 49v106.1l-86.3-48.9V211.3zm108.7 155.1V260.3l86.6-49v106.1l-86.6 49zm-11.2-223.1l86.2 48.8-86.2 48.8-86-48.8 86-48.8z"
        />
        <path
          className="prefix__st0"
          d="M212.5 486.6l-11 19.5 15 8.5a10.838 10.838 0 0011 0l15-8.5-11.1-19.5h-18.9zm19.1-457.1l11-19.5-15-8.5c-3.4-1.9-7.6-1.9-11 0l-15 8.5 11 19.5h19zm180.2 354.9l11.1 19.5 15-8.5c3.5-2 5.7-5.7 5.7-9.7v-17.3h-22.4l-9.4 16z"
        />
        <path
          d="M542.9 162.3h44.3c.7 0 1.4.4 1.7 1.1L638.7 265c.7 1.4 2.7 1.4 3.4 0l49.6-101.7c.3-.6 1-1.1 1.7-1.1h44c1 0 1.9.8 1.9 1.9V352c0 1-.8 1.9-1.9 1.9h-44.1c-1 0-1.9-.8-1.9-1.9V251.9c0-2-2.7-2.6-3.6-.8l-33.7 69c-.3.6-1 1.1-1.7 1.1h-24.1c-.7 0-1.4-.4-1.7-1l-34-69.1c-.9-1.8-3.6-1.2-3.6.8V352c0 1-.8 1.9-1.9 1.9H543c-1 0-1.9-.8-1.9-1.9V164.1c0-1 .8-1.8 1.8-1.8zm292.8 0h49.2c.8 0 1.5.5 1.8 1.2l71.7 187.8c.5 1.2-.4 2.6-1.8 2.6h-46c-.8 0-1.5-.5-1.8-1.2l-16.3-41.1c-.3-.7-1-1.2-1.8-1.2h-61.4c-.8 0-1.5.5-1.8 1.2l-16 41c-.3.7-1 1.2-1.8 1.2H764c-1.3 0-2.2-1.3-1.8-2.6L834 163.5c.2-.8.9-1.2 1.7-1.2zm48.9 110.1L861.8 213c-.6-1.6-2.9-1.6-3.5 0l-22.6 59.5c-.5 1.2.4 2.6 1.8 2.6h45.4c1.3-.1 2.2-1.4 1.7-2.7zm102.9-110.1h44.1c1 0 1.9.8 1.9 1.9v67.6c0 1.7 2.1 2.5 3.3 1.2l62.2-70c.4-.4.9-.6 1.4-.6h49.8c1.6 0 2.5 1.9 1.4 3.1l-64.8 74.1c-.5.6-.6 1.5-.2 2.2l70 109.3c.8 1.2-.1 2.9-1.6 2.9h-46.7c-.7 0-1.3-.3-1.6-.9l-49.3-79.7c-.7-1.1-2.1-1.2-3-.3l-20.4 22.3c-.3.3-.5.8-.5 1.3V352c0 1-.8 1.9-1.9 1.9h-44.1c-1 0-1.9-.8-1.9-1.9V164.1c0-1 .9-1.8 1.9-1.8zm198.2 0h137.5c1 0 1.9.8 1.9 1.9v33.1c0 1-.8 1.9-1.9 1.9h-89.6c-1 0-1.9.8-1.9 1.9v36.4c0 1 .8 1.9 1.9 1.9h78.6c1 0 1.9.8 1.9 1.9V275c0 1-.8 1.9-1.9 1.9h-78.6c-1 0-1.9.8-1.9 1.9v36.4c0 1 .8 1.9 1.9 1.9h89.6c1 0 1.9.8 1.9 1.9v33c0 1-.8 1.9-1.9 1.9h-137.5c-1 0-1.9-.8-1.9-1.9V164.1c0-1 .8-1.8 1.9-1.8z"
          fill="#191919"
        />
        <path
          className="prefix__st1"
          d="M1388.2 354c-11.3-1.8-20.3-3.9-26.9-6.5-.7-.3-1.2-1-1.2-1.7V310c0-1.3 1.4-2.2 2.6-1.7 7 3 14.7 5.2 22.9 6.7 9.2 1.7 18.2 2.5 26.9 2.5 12.9 0 22.4-1.7 28.4-5.2s9.1-9.6 9.1-18.3c0-6.9-2.6-12-7.7-15.2-5.2-3.2-12.8-4.8-22.9-4.8h-29.2c-1.1 0-2-.9-1.9-2l2.9-29.9c.1-1 .9-1.7 1.9-1.7h24.2c10.1 0 17.5-1.6 22-4.9 4.6-3.3 6.8-8.6 6.8-15.9 0-7.1-2.8-12.4-8.3-15.9-5.6-3.5-14.3-5.2-26.2-5.2-8.5 0-17.1.9-25.7 2.8-7.5 1.6-14.3 3.7-20.2 6.2-1.2.5-2.6-.4-2.6-1.7v-35.2c0-.8.5-1.4 1.2-1.7 6.9-2.8 15.3-5 25.2-6.8 10.4-1.9 20.8-2.8 31.1-2.8 15.9 0 29.4 2.3 40.6 7 11.2 4.7 19.7 11.1 25.4 19.2 5.7 8.1 8.6 17.6 8.6 28.3 0 9.5-2 18.1-5.9 25.9-3.4 6.6-8.1 11.8-14.3 15.7-1.2.8-1.1 2.7.2 3.3 7.2 3.2 12.8 7.8 16.7 13.9 4.6 7 6.8 15.7 6.8 26 0 19.4-7.1 34-21.3 43.7-14.2 9.7-33.4 14.6-57.6 14.6-9-.1-19.6-1-31.6-2.9zm141.2-189.9c0-1 .8-1.9 1.9-1.9h81.1c29.9 0 52.4 7.6 67.4 22.9 15 15.3 22.5 40 22.5 74.1 0 32.3-7.5 56.2-22.5 71.5-15 15.4-37.4 23.1-67.4 23.1h-81.1c-1 0-1.9-.8-1.9-1.9V164.1zm76.5 152.9c11.1 0 20-1.6 26.8-4.8 6.7-3.2 11.9-8.9 15.5-17.3 3.6-8.3 5.4-20.2 5.4-35.7 0-15.7-1.6-27.8-4.9-36.4-3.3-8.6-8.3-14.7-15.2-18.3-6.8-3.6-16-5.4-27.5-5.4h-26.7c-1 0-1.9.8-1.9 1.9v114.1c0 1 .8 1.9 1.9 1.9h26.6z"
        />
      </g>
    </svg>
  )
}

export default Logo;
